module.exports = __webpack_public_path__ + "img/share_icon.1e35368.png";